import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  reactive,
  watch,
  ref,
  onMounted,
} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Expansion',
  props: {
  expanded: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  duration: {
    type: Number,
    required: false,
    default: () => 0.575,
  },
},
  setup(__props) {

const props = __props;
const root = ref<InstanceType<typeof HTMLElement>>();
const isExpanded = reactive({ value: props.expanded });

watch(() => props.expanded, () => {
  isExpanded.value = props.expanded;
});

const enter = (element: HTMLElement) => {
  const $el = element;
  const { width } = getComputedStyle($el);

  $el.style.width = width;
  $el.style.position = 'absolute';
  $el.style.visibility = 'hidden';
  $el.style.height = 'auto';

  const { height } = getComputedStyle($el);

  $el.style.width = '';
  $el.style.position = '';
  $el.style.visibility = '';
  $el.style.height = '0';

  const heightFix = getComputedStyle($el).height;

  requestAnimationFrame(() => {
    $el.style.height = height;
  });

  return heightFix;
};

const afterEnter = (element: HTMLElement) => {
  const $el = element;

  $el.style.height = 'auto';
};

const leave = (element: HTMLElement) => {
  const $el = element;
  const { height } = getComputedStyle($el);

  $el.style.height = height;

  const heightFix = getComputedStyle($el).height;

  requestAnimationFrame(() => {
    $el.style.height = '0';
  });

  return heightFix;
};

onMounted(() => {
  if (root.value) {
    root.value.style.setProperty('--expansion-duration', `${props.duration}s`);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["expansion", { 'expanded': isExpanded.value }]),
    ref_key: "root",
    ref: root
  }, [
    _createVNode(_Transition, {
      name: "expansion",
      onEnter: enter,
      onAfterEnter: afterEnter,
      onLeave: leave
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "default")
        ], 512), [
          [_vShow, isExpanded.value]
        ])
      ]),
      _: 3
    })
  ], 2))
}
}

})